import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ApiUsers, GungSettingsApiUsersService } from '../../../services/gung-settings-api-users.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiEntity, GungSettingsApiService } from '../../../services/gung-settings-api.service';
import { first, forkJoin, of, switchMap } from 'rxjs';
import { FormBuilder, FormGroup, NgModel, Validators } from '@angular/forms';
import { gungAddRemoveSpinner, GungNotificationService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';
import { BackendFeatureService } from '../../../services/backend-feature.service';
import { PasswordPolicyService } from '../../../services/password-policy.service';

@Component({
  selector: 'lib-gung-settings-api-users-edit-modal',
  templateUrl: './gung-settings-api-users-edit-modal.component.html',
  styleUrl: './gung-settings-api-users-edit-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class GungSettingsApiUsersEditModalComponent implements OnInit {
  user: ApiUsers;

  delegate;
  componentId: string;
  suffix: string;
  userForm: FormGroup;
  entities: ApiEntity[]
  loading = true;
  entitiesModel = {};
  passwordRequirements: any;

  validPassword: string;
  password = '';

  @ViewChild('passwordModel') passwordModel!: NgModel;
  

  constructor(
    public activeModal: NgbActiveModal,
    protected gungSettingsApiService: GungSettingsApiService,
    protected fb: FormBuilder,
    protected userApiService: GungSettingsApiUsersService,
    protected notificationService: GungNotificationService,
    protected translationService: TranslateService,
    protected backendFeatureService: BackendFeatureService,
    protected passwordPolicyService: PasswordPolicyService
  ) {}

  ngOnInit(): void {

    const featureId = 'passwordPolicies';


    this.componentId = GungSettingsApiUsersEditModalComponent.name;
    forkJoin({
      suffix: this.gungSettingsApiService.getCustomerSufix().pipe(first()),
      entities: this.gungSettingsApiService.getApiEntities().pipe(first()),
      isActivated: this.backendFeatureService.isActivated(featureId).pipe(first())
    }).pipe(
      switchMap(({suffix, entities, isActivated}) =>
      forkJoin({
        suffix: of(suffix),
        entities: of(entities),
        requirements: isActivated ? this.passwordPolicyService.getPasswordRequirements().pipe(first()) : of({})
      })
    )).subscribe(({suffix, entities, requirements}) =>{
      this.passwordRequirements = requirements;
      this.suffix = suffix.suffix;
      this.entities = entities;
      this.initForm();
      this.loading = false;
    })

  }

  initForm(): void {
    this.userForm = this.fb.group({
      username: this.fb.control(this.user?.username || '', [Validators.required]),
      password: this.fb.control('', !this.user ? [Validators.required]: null)
    });
    for (const entity of this.entities) {
      this.entitiesModel[entity.entity] = {
        read: false,
        write: false,
        transformer: null
      }
      if(this.user){
        const userHasEntity = this.user.accessList.find(e => e.entity === entity.entity)
        if(userHasEntity){
          this.entitiesModel[entity.entity].read = userHasEntity.read;
          this.entitiesModel[entity.entity].write = userHasEntity.write;
          this.entitiesModel[entity.entity].transformer = userHasEntity.transformer;
        }
      }
      
    }
  }

  generatePassword(length: number = 16): void {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()';
    const generatedPassword = Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    
    this.userForm.patchValue({ password: generatedPassword });
  }

  isValid(event) {
    this.validPassword = event;
    if(this.validPassword){
      this.userForm.patchValue({ password: this.password })
    }
   
  }



  save({ target }): void {
    if (this.userForm && this.userForm.invalid || (!this.user && !this.validPassword)) {
      this.userForm.markAllAsTouched();
      return;
    }
    gungAddRemoveSpinner(target);
    const rawFormData = this.userForm.getRawValue();
    let payload: ApiUsers = {
      username: rawFormData.username,
      accessList: []
    }
    if(rawFormData.password){
      payload.password = rawFormData.password;
    }
    for (const entity in this.entitiesModel) {
      if (Object.prototype.hasOwnProperty.call(this.entitiesModel, entity)) {
        const element = this.entitiesModel[entity];
        if(element.read || element.write){
          payload.accessList.push({
            entity: entity,
            read: element.read,
            write: element.write,
            transformer: element.transformer
          })
        }
      }
    }
    this.userApiService.save(payload).pipe(first()).subscribe(response =>{
      if(response.success){
        if(this.user){
          this.notificationService.notify('', this.translationService.instant('USER_EDITED_SUCCESSFUL'), 'success');
        }else{
          this.notificationService.notify('', this.translationService.instant('USER_CREATED_SUCCESSFUL'), 'success');
        }
      }else{
        this.notificationService.notify('', this.translationService.instant('ERROR'), 'error');
      }
      this.delegate.modalRef.get(this.componentId).close({});
      gungAddRemoveSpinner(target);
    })
  }
}
